import React from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { resolvePath } from '@/utils/resolvePath';
import { trackEventAPI } from '@/analytics/middleware';
import { NavItem, IconWrapper, Label } from './styles';
import { NEW_ROUTEMAP } from '@/constants/routes';

interface BottomNavItemProps {
    href: string;
    inactiveIcon: string;
    activeIcon: string;
    label: string;
    exactMatch?: boolean;
    actionName: string;
}

export default function BottomNavItem({
    href,
    inactiveIcon,
    activeIcon,
    label,
    actionName,
}: BottomNavItemProps) {
    const router = useRouter();
    const isActive = label === 'Service';

    const currentIcon = isActive ? activeIcon : inactiveIcon;

    const handleClick = () => {
        try {
            if (router.pathname !== href) {
                window.location.href = href;
            }
            trackEventAPI({
                event_name: actionName,
                customAttributes: {
                    action_name: actionName,
                    section: 'Bottom Navigation',
                    page_type: 'Bottom Navigation',
                },
                isFakeDoor: true,
            });
        } catch (error) {
            console.error('Navigation error:', error);
        }
    };

    return (
        <NavItem
            isActive={isActive}
            className={isActive ? 'active' : ''}
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    handleClick();
                }
            }}
        >
            <IconWrapper className="iconWrapper">
                <Image
                    src={resolvePath(currentIcon)}
                    alt={label}
                    width={24}
                    height={24}
                    priority
                />
            </IconWrapper>
            <Label>{label}</Label>
        </NavItem>
    );
}
